import { loadLiveEditor } from './liveEditorLoader';

/** Shared by React.lazy and creation: start complete detail code alongside the request. */
export const loadLiveDetails = () => import('../../components/business/details/Live').then(m => ({default:m.LiveDetails}));
export const loadPurchaseDetails = () => import('../../components/business/details/Purchase').then(m => ({default:m.PurchaseDetails}));
export const loadPurchaseWorkspace = () => import('../../components/business/lists/PurchaseProducts').then(m => ({default:m.PurchaseProductList}));
export const preloadCreationEditor = (resource:string):Promise<unknown> => {
    switch(resource) {
        case 'live': return Promise.all([loadLiveDetails(), loadLiveEditor()]);
        case 'purchase': return Promise.all([loadPurchaseDetails(), loadPurchaseWorkspace()]);
        case 'suppliers': return import('../../components/business/forms/Supplier');
        case 'inventory': return import('../../components/business/forms/ProductEntry');
        case 'products': return import('../../components/business/forms/SupplierProduct');
        default: return Promise.resolve();
    }
};
